module.exports = __webpack_public_path__ + "img/a2.9446a99b.jpg";